import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const CalloutWarningIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={18}
        viewBox="0 0 20 18"
        className="Icon callout-warning"
        {...props}
    >
        <g fill="none" fillRule="evenodd">
            <path
                fill="#FFCE26"
                d="m11.307 2.324 7.436 13.218a1.5 1.5 0 0 1-1.308 2.236H2.565a1.5 1.5 0 0 1-1.308-2.236L8.693 2.324a1.5 1.5 0 0 1 2.614 0z"
            />
            <path
                fill="#1A1A1A"
                fillRule="nonzero"
                d="M9.5 12.25h1L11 6.5H9l.5 5.75zm.5 3.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
            />
        </g>
    </svg>
);
const Memo = memo(CalloutWarningIcon);
export default Memo;
